/**
 * Labstep
 *
 * @module constants/organization-logout-timeout
 * @desc Defines organization-specific timeout durations for user sessions.
 */

import { ORGANIZATION_IDENTIFIERS } from 'labstep-web/constants/organization-identifiers';
import { UserOrganizationType } from 'labstep-web/models/user-organization.model';

type OrganizationTimeoutConfig = {
  [UserOrganizationType.admin]: number;
  [UserOrganizationType.member]: number;
  [UserOrganizationType.guest]: number;
  [UserOrganizationType.viewer]: number;
};

export type OrganizationLogoutTimeouts = {
  [K in keyof typeof ORGANIZATION_IDENTIFIERS]: OrganizationTimeoutConfig;
};

export const ORGANIZATION_LOGOUT_TIMEOUTS: OrganizationLogoutTimeouts =
  {
    [ORGANIZATION_IDENTIFIERS.labstep]: {
      [UserOrganizationType.admin]: 7 * 24 * 3600 * 1000,
      [UserOrganizationType.member]: 7 * 24 * 3600 * 1000,
      [UserOrganizationType.guest]: 7 * 24 * 3600 * 1000,
      [UserOrganizationType.viewer]: 7 * 24 * 3600 * 1000,
    },
    [ORGANIZATION_IDENTIFIERS.ochrebio]: {
      [UserOrganizationType.admin]: 24 * 3600 * 1000,
      [UserOrganizationType.member]: 24 * 3600 * 1000,
      [UserOrganizationType.guest]: 24 * 3600 * 1000,
      [UserOrganizationType.viewer]: 24 * 3600 * 1000,
    },
    [ORGANIZATION_IDENTIFIERS.djsantibodies]: {
      [UserOrganizationType.admin]: 4 * 3600 * 1000,
      [UserOrganizationType.member]: 4 * 3600 * 1000,
      [UserOrganizationType.guest]: 4 * 3600 * 1000,
      [UserOrganizationType.viewer]: 4 * 3600 * 1000,
    },
    [ORGANIZATION_IDENTIFIERS.miravista_diagnostics_llc]: {
      [UserOrganizationType.admin]: 1 * 3600 * 1000,
      [UserOrganizationType.member]: 1 * 3600 * 1000,
      [UserOrganizationType.guest]: 1 * 3600 * 1000,
      [UserOrganizationType.viewer]: 1 * 3600 * 1000,
    },
    [ORGANIZATION_IDENTIFIERS.university_of_edinburgh]: {
      [UserOrganizationType.admin]: 4 * 3600 * 1000,
      [UserOrganizationType.member]: 12 * 3600 * 1000,
      [UserOrganizationType.guest]: 12 * 3600 * 1000,
      [UserOrganizationType.viewer]: 12 * 3600 * 1000,
    },
  };
